import Link from "next/link";
import styled from "styled-components";
import AuthModal from "../Auths";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserLogout, selectAuthState, setOpenAuthModal } from "@/stores/slices/authSlice";
import { RAButtonSecondary, RATypography } from "@/components/customs";
import { Row, Col, Grid } from "antd";
import { PATH_ROUTES } from "@/config/routes";
import { useRouter } from "next/router";
import {
	SvgCharter,
	SvgJetOneSuites,
	SvgLogout,
	SvgProfile,
	SvgSetting,
	SvgAirFreight,
	SvgDashboard,
} from "@/assets/icons";
import { HeaderDesktop } from "./HeaderDesktop";
import { HeaderMobile } from "./mobile";
import { ModalActiveAccount, ModalRequestQuote, ModalStatus } from "../Modals";
import { NOTIFICATION_TYPE } from "@/config/constants";
import { isBoolean } from "lodash";
import Script from "next/script";

const { useBreakpoint } = Grid;

export const HeaderHome = () => {
	const dispatch = useDispatch();
	const router = useRouter();
	const screens = useBreakpoint();
	const { user } = useSelector(selectAuthState);
	const [showStatus, setShowStatus] = useState(false);
	const [showModalActiveAccount, setShowModalActiveAccount] = useState(false);
	const [forceSubmitRequest, setForceSubmitRequest] = useState(false);

	const [openFlightRequest, setOpenFlightRequest] = useState(false);

	useEffect(() => {
		const updateVH = () => {
			const vh = window.visualViewport?.height || window.innerHeight;
			document.documentElement.style.setProperty("--vh", `${vh * 0.01}px`);
		};

		updateVH();
	}, []);

	// check query login & mode
	useEffect(() => {
		if (router.query?.login === "true") {
			let mode = "LOGIN"; // "REGISTER"
			if (router.query?.mode) mode = router.query?.mode;
			dispatch(setOpenAuthModal({ mode }));
		}
	}, [router.query]);

	const onLogout = () => {
		dispatch(fetchUserLogout());
	};

	const onPressRequestQuote = () => {
		if (user && !user.activated) {
			setShowStatus(true);
			return;
		}
		setOpenFlightRequest(true);
	};

	const userMenuOptions = [
		{
			key: PATH_ROUTES.PATH_ACCOUNT_DASHBOARD,
			label: (
				<Link href={PATH_ROUTES.PATH_ACCOUNT_DASHBOARD} data-testid="UserMenu_dashboardLink">
					<CardUserProfileItem title="Dashboard" icon={<SvgDashboard color="#595959" />} active={true} />
				</Link>
			),
		},
		{
			key: PATH_ROUTES.PATH_ACCOUNT_MY_PROFILE,
			label: (
				<Link href={PATH_ROUTES.PATH_ACCOUNT_MY_PROFILE} data-testid="UserMenu_myProfileLink">
					<CardUserProfileItem title="My Profile" icon={<SvgProfile color="#595959" />} active={true} />
				</Link>
			),
		},
		{
			key: PATH_ROUTES.PATH_ACCOUNT_JET_ONE_SUITES,
			label: (
				<Link href={PATH_ROUTES.PATH_ACCOUNT_JET_ONE_SUITES}>
					<CardUserProfileItem
						title="Jet 1 Suites"
						icon={<SvgJetOneSuites color="#595959" />}
						active={true}
					/>
				</Link>
			),
		},
		{
			key: PATH_ROUTES.PATH_ACCOUNT_CHARTER,
			label: (
				<Link href={PATH_ROUTES.PATH_ACCOUNT_CHARTER}>
					<CardUserProfileItem title="Charter" icon={<SvgCharter color="#595959" />} active={true} />
				</Link>
			),
		},
		{
			key: PATH_ROUTES.PATH_ACCOUNT_AIR_FREIGHT,
			label: (
				<Link href={PATH_ROUTES.PATH_ACCOUNT_AIR_FREIGHT}>
					<CardUserProfileItem title="Air Freight" icon={<SvgAirFreight color="#595959" />} active={true} />
				</Link>
			),
		},
		{
			key: PATH_ROUTES.PATH_ACCOUNT_SETTINGS,
			label: (
				<Link href={PATH_ROUTES.PATH_ACCOUNT_SETTINGS}>
					<CardUserProfileItem
						title="Settings & Alerts"
						icon={<SvgSetting color="#595959" />}
						active={true}
					/>
				</Link>
			),
		},
		{
			key: "logout",
			label: (
				<Link
					href="/"
					onClick={() => {
						onLogout();
					}}
				>
					<CardUserProfileItem title="Logout" icon={<SvgLogout color="#595959" />} active={true} />
				</Link>
			),
		},
	];

	const userMenuMobileOptions = [
		{
			key: PATH_ROUTES.PATH_ACCOUNT_DASHBOARD,
			label: (
				<Link href={PATH_ROUTES.PATH_ACCOUNT_DASHBOARD}>
					<CardUserProfileItem
						title="Dashboard"
						icon={<SvgDashboard color="#595959" />}
						active={router.pathname === PATH_ROUTES.PATH_ACCOUNT_DASHBOARD}
					/>
				</Link>
			),
		},
		{
			key: PATH_ROUTES.PATH_ACCOUNT_MY_PROFILE,
			label: (
				<Link href={PATH_ROUTES.PATH_ACCOUNT_MY_PROFILE}>
					<CardUserProfileItem
						title="My Profile"
						icon={<SvgProfile color="#595959" />}
						active={router.pathname === PATH_ROUTES.PATH_ACCOUNT_MY_PROFILE}
					/>
				</Link>
			),
		},
		{
			key: PATH_ROUTES.PATH_ACCOUNT_JET_ONE_SUITES,
			label: (
				<Link href={PATH_ROUTES.PATH_ACCOUNT_JET_ONE_SUITES}>
					<CardUserProfileItem
						title="Jet 1 Suites"
						icon={<SvgJetOneSuites color="#595959" />}
						active={router.pathname === PATH_ROUTES.PATH_ACCOUNT_JET_ONE_SUITES}
					/>
				</Link>
			),
		},
		{
			key: PATH_ROUTES.PATH_ACCOUNT_CHARTER,
			label: (
				<Link href={PATH_ROUTES.PATH_ACCOUNT_CHARTER}>
					<CardUserProfileItem
						title="Charter"
						icon={<SvgCharter color="#595959" />}
						active={router.pathname === PATH_ROUTES.PATH_ACCOUNT_CHARTER}
					/>
				</Link>
			),
		},
		{
			key: PATH_ROUTES.PATH_ACCOUNT_AIR_FREIGHT,
			label: (
				<Link href={PATH_ROUTES.PATH_ACCOUNT_AIR_FREIGHT}>
					<CardUserProfileItem
						title="Air Freight"
						icon={<SvgAirFreight color="#595959" />}
						active={router.pathname === PATH_ROUTES.PATH_ACCOUNT_AIR_FREIGHT}
					/>
				</Link>
			),
		},
		{
			key: PATH_ROUTES.PATH_ACCOUNT_SETTINGS,
			label: (
				<Link href={PATH_ROUTES.PATH_ACCOUNT_SETTINGS}>
					<CardUserProfileItem
						title="Settings & Alerts"
						icon={<SvgSetting color="#595959" />}
						active={router.pathname === PATH_ROUTES.PATH_ACCOUNT_SETTINGS}
					/>
				</Link>
			),
		},
		{
			key: "logout",
			label: (
				<Link
					href="/"
					onClick={() => {
						onLogout();
					}}
				>
					<CardUserProfileItem title="Logout" icon={<SvgLogout color="#595959" />} />
				</Link>
			),
		},
	];

	return (
		<HeaderContainer>
			{isBoolean(screens?.lg) && (
				<>
					{screens?.lg ? (
						<HeaderDesktop
							onClickOpenLogin={() => dispatch(setOpenAuthModal())}
							userMenuOptions={userMenuOptions}
							onPressRequestQuote={onPressRequestQuote}
							openFlightRequest={openFlightRequest}
						/>
					) : (
						<HeaderMobile
							onClickOpenLogin={() => dispatch(setOpenAuthModal())}
							userMenuOptions={userMenuMobileOptions}
							onPressRequestQuote={onPressRequestQuote}
							asPath={router.pathname}
						/>
					)}
				</>
			)}

			<AuthModal onFinish={() => setForceSubmitRequest(true)} />
			<ModalRequestQuote
				visible={openFlightRequest}
				onClose={() => setOpenFlightRequest(false)}
				forceSubmitRequest={forceSubmitRequest}
				onUpdateForceSubmitRequest={setForceSubmitRequest}
			/>
			<ModalStatus
				visible={showStatus}
				status={NOTIFICATION_TYPE.ERROR}
				title="You haven't verified your OTP yet!"
				note="Please verify your OTP to access all the features and benefits of our products"
				onClose={() => setShowStatus(false)}
				footer={
					<Row>
						<RAButtonSecondary
							title="VERIFY NOW"
							onClick={() => {
								setShowStatus(false);
								setTimeout(() => {
									setShowModalActiveAccount(true);
								}, 200);
							}}
						/>
					</Row>
				}
			/>
			<ModalActiveAccount
				visible={showModalActiveAccount}
				onClose={() => setShowModalActiveAccount(false)}
				onActiveSuccess={() => {
					setOpenFlightRequest(true);
				}}
			/>
		</HeaderContainer>
	);
};

const CardUserProfileItem = ({ icon, title = "", active = false }) => (
	<Row style={{ padding: "4px 52px 4px 4px" }} gutter={12}>
		<Col>{icon}</Col>
		<Col>
			<RATypography variant={active ? "sub-heading4" : "body3"} color={active ? "#222222" : "#595959"}>
				{title}
			</RATypography>
		</Col>
	</Row>
);

const HeaderContainer = styled.header`
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	z-index: 999;
	display: flex;
	justify-content: center;
`;
